import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnDestroy, OnInit, DOCUMENT } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SwitchThemeService } from './switch-theme.service';
import { ButtonComponent } from '@teorema/patron';
import { AuthService } from '@app/auth/auth.service';
import { constants } from '@app/shared/utils';

@Component({
  selector: 'patron-switch-theme',
  templateUrl: './switch-theme.component.html',
  imports: [CommonModule, ButtonComponent],
})
export class SwitchThemeComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  switchThemeService = inject(SwitchThemeService);
  config = this.authService.getCoreConfig();
  loadingTheme: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    this.switchThemeService.currentTheme.pipe(takeUntil(this.destroy$)).subscribe(theme => {
      localStorage.setItem(constants.patronThemeKey, theme);
      this.document.documentElement.classList.remove('light-theme', 'dark-theme');
      this.document.documentElement.classList.add(`${theme}-theme`);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
